import { createSlice } from "@reduxjs/toolkit";

export interface IResolution {
	id: number,
	name: string,
	description: string|null,
	width: number,
	height: number,
	created_at: string|null,
	updated_at: string|null,
}

export interface ResolutionState {
	resolutions: IResolution[],
	resolution: IResolution|null,
	search: IResolution[],

	creating: boolean,
	deleting: boolean,
	updating: boolean,
	gettingList: boolean,
	gettingItem: boolean,
	searching: boolean,

	isError: boolean,
	errorCode: number,
	errorMessage: string|null,
}

export const initialState: ResolutionState = {
	resolutions: [],
	resolution: null,
	search: [],

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,
	searching: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const ResolutionSlice = createSlice({
	name: 'resolution',
	initialState,
	reducers: {

		clearResolutionItem: (state, action): ResolutionState => {
			return { ...state, resolution: null };
		},

		clearResolutionSearchResult: (state, action): ResolutionState => {
			return { ...state, search: [] };
		},

		onLoadCreate: (state, action ): ResolutionState => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ): ResolutionState => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ): ResolutionState => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ): ResolutionState => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ): ResolutionState => {
			return {...state, gettingItem: true};
		},

		onLoadSearch: (state, action ): ResolutionState => {
			return {...state, search: [], searching: true};
		},

		// Success
		onSuccessCreate: (state, action): ResolutionState => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action): ResolutionState => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action): ResolutionState => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action): ResolutionState => {
			return {...state, resolutions: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action): ResolutionState => {
			return {...state, resolution: action.payload.data, gettingItem: false};
		},

		onSuccessSearch: (state, action): ResolutionState => {
			return {...state, search: action.payload.data, searching: false};
		},

		// Errors
		onFailCreate: (state, action): ResolutionState => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action): ResolutionState => {
			return {...state, deleting: false };
		},
		onFailUpdate: (state, action): ResolutionState => {
			return {...state, updating: false };
		},
		onFailList: (state, action): ResolutionState => {
			return {...state, resolutions: [] };
		},
		onFailItem: (state, action): ResolutionState => {
			return {...state, resolution: null };
		},
		onFailSearch: (state, action): ResolutionState => {
			return { ...state, search: [], searching: false };
		},
	},
});

export const {
	clearResolutionItem,
	clearResolutionSearchResult
} = ResolutionSlice.actions;
